import { Component, OnInit } from '@angular/core';
// import * as jspdf from 'jspdf';
// import html2canvas from 'html2canvas';

@Component({
  selector: 'app-contrato',
  templateUrl: './contrato.component.html',
  styleUrls: ['./contrato.component.scss']
})
export class ContratoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  downloadPDF() {
    // let printContents, popupWin;
    // printContents = document.getElementById('content').innerHTML;
    // popupWin = window.open('', '_blank', '');
    // popupWin.document.open();
    // popupWin.document.write(`
    //   <html>
    //     <head>
    //       <style>
    //       //........Customized style.......
    //       </style>
    //     </head>
    // <body onload="window.print();window.close()">${printContents}</body>
    //   </html>`
    // );
    // popupWin.document.close();
    // const doc = new jsPDF();

    // const specialElementHandlers = {
    //   '#editor': function (element, rendered) {
    //     return true;
    //   }
    // };
    // const content = this.content.nativeElement;

    // console.log(content.innerHTML);
    // doc.fromHTML(content.innerHTML, 15, 15, {
    // });
    // doc.save('prova.pdf');

    // const data = document.getElementById('content');
    // html2canvas(data).then(canvas => {
    //   // Few necessary setting options
    //   const imgWidth = 400;
    //   const imgHeight = canvas.height * imgWidth / canvas.width;

    //   const contentDataURL = canvas.toDataURL('image/png');
    //   const pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
    //   const position = 0;
    //   pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
    //   pdf.save('MYPdf.pdf'); // Generated PDF
    // });
    // const doc = new jspdf();
    // doc.addHTML(document.getElementById("content"), function() {
    //    doc.save("obrz.pdf");
    // });
  }

}
